import React, { useEffect, useState } from 'react';
import MainLayoutWithoutFooter from '../components/MainLayoutWithoutFooter';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { toast } from 'react-toastify';


const OrderTransferTable = () => {
  const [records, setRecords] = useState([]);
  const [fromTable, setFromTable] = useState('');
  const [toTable, setToTable] = useState('');
  const [loading, setLoading] = useState(false);

  
  useEffect(() => {
    fetchTableListing();
  }, []);

  const fetchTableListing = async () => {
    try {
      const response = await callAPI(apiUrls.TABLE_LISTING, { }, 'GET');
      if (response.data?.tables) {
        setRecords(response.data.tables);
      }
    } catch (error) {
      toast.error('Failed to load table data');
      console.error(error);
    }
  };

  const handleSubmit = async () => {
    if (!fromTable) {
      return toast.error('Please select an occupied table.');
    }

    if (!toTable) {
      return toast.error('Please select an available table.');
    }

    const payload = {
      from_table: fromTable,
      to_table: toTable,
    };

    try {
      setLoading(true);
      const response = await callAPI(apiUrls.UPDATE_TABLE_OCCUPANCY, {}, 'POST', payload, {});
      if (response.status) {
        toast.success(response.data.message || 'Table transferred successfully!');
        setFromTable('');
        setToTable('');
        fetchTableListing(); 
      } else {
        toast.error(response.data.message || 'Something went wrong during transfer.');
      }
    } catch (error) {
      toast.error('Transfer failed. Please try again.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayoutWithoutFooter>
      <div className="pageContent transferOptionsPage dflexCol pb-3">
        <div className="container">
          <div className="selectCustomerCol">
            <h4 className="lgTitle text-center pb-3">Transfer Table</h4>
            <form className="formStyle">
              <div className="row g-3 g-lg-4">
                <div className="col-12 col-md-6">
                  <label className="form-label">Move Guest From Table</label>
                  <select
                    className="form-select"
                    value={fromTable}
                    onChange={(e) => setFromTable(e.target.value)}
                  >
                    <option value="">Select Occupied Table</option>
                    {records
                      .filter((table) => table.table_id) 
                      .map((table) => (
                        <option key={table.id} value={table.id}>
                          {table.name}
                        </option>
                      ))}
                  </select>
                </div>

                
                <div className="col-12 col-md-6">
                  <label className="form-label">Move Guest To Table</label>
                  <select
                    className="form-select"
                    value={toTable}
                    onChange={(e) => setToTable(e.target.value)}
                  >
                    <option value="">Select Available Table</option>
                    {records
                      .filter((table) => !table.table_id) 
                      .map((table) => (
                        <option key={table.id} value={table.id}>
                          {table.name}
                        </option>
                      ))}
                  </select>
                </div>


                <div className="col-12">
                  <div className="tableItemList">
                    <ul>
                      <li>All the items ordered will move to that table</li>
                      <li>The tables will show correctly the updated status. Available or Occupied.</li>
                    </ul>
                  </div>
                </div>

                
                <div className="col-12 text-center">
                  <div className="pt-4">
                    <button
                      type="button"
                      className="btn btnPrimary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? 'Transferring...' : 'Transfer Table'}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </MainLayoutWithoutFooter>
  );
};

export default OrderTransferTable;
